import { Box, Text, Group } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import styles from './ManagementShell.module.css';

export default function Footer() {
  const { t } = useTranslation('miscUI');
  const currentYear = new Date().getFullYear();

  return (
    <Box
      className={styles.footer}
      style={{
        padding: '12px 16px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexShrink: 0
      }}
    >
      <Group gap="md">
        <Text size="xs" c="dimmed">
          {t('footer.copyright', { year: currentYear })}
        </Text>
        <Text size="xs" c="dimmed" style={{ opacity: 0.5 }}>
          •
        </Text>
        <Text size="xs" c="dimmed">
          v2.0
        </Text>
      </Group>
    </Box>
  );
}
